/**
 * How a field on the employee record is presented.
 *
 * The two rules that matter — identifiers are monospace, an absent value is a
 * muted dash — are product-wide and now live in `utils/fieldDisplay`. They are
 * re-exported here so the record's screens keep one import, and so there is one
 * implementation rather than a copy per module.
 */
export { isIdentifier, displayValue, isEmptyValue } from "../../../../../../../utils/fieldDisplay";

/** Rows that are not worth showing as text at all. */
export const isRenderableRow = (row) => row?.field !== "profileImage";

export const visibleRows = (rows = []) => (rows || []).filter(isRenderableRow);
